import React, { useRef , useState} from "react";
import Frame from "./Frame";
import {Box, useTheme, Typography,Button, ButtonBase, Dialog, DialogTitle,DialogContentText,DialogActions, TextField, DialogContent} from "@mui/material";
import { tokens } from "../../theme";
import { useDispatch, useSelector } from "react-redux";
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import EditIcon from '@mui/icons-material/Edit';
import { setName } from "../../slices/sign_image_editor"


const InfoArea = (props) =>  {

  const {imageId} = props;

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const dispatch = useDispatch();

  const thisImage = useSelector((state) => state.imageEditor);

  const totalFrames = thisImage.frames.length; 
  const totalDuration = thisImage.frames.reduce((accumulator, object) => {
    return accumulator + object.duration;
  }, 0)

  const [defaultDuration, setDefaultDuration] = useState(thisImage.defaultDuration); 

  const [editNameOpen, setEditNameOpen] = useState(false)
  const [newName, setNewName] = useState(thisImage.name);

  const handleNameChangeOpen = () => {

    setEditNameOpen(true);
  }

  const handleChange = (event) => {
    setNewName(event.target.value);
  };

  const handleNameChangeClose = () =>{
    setEditNameOpen(false);
  }

  const saveName = () =>{

    dispatch(setName(newName));
    setEditNameOpen(false);
    

  }

  return (
    <>
    <Dialog
      open={editNameOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Chnage the name of the image
      </DialogTitle>
      <DialogContent>
     
      <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Image Name"
            type="text"
            fullWidth
            variant="standard"
            value ={newName}
            onChange={handleChange}
          />
</DialogContent>
      <DialogActions>
        <Button onClick={handleNameChangeClose} autoFocus>Cancel</Button>
        <Button onClick={saveName}>
          Update
        </Button>
      </DialogActions>
    </Dialog>

    <Box
        display = "flex"
        flexDirection="column"
        width = "100%"
        backgroundColor={colors.primary[300]} 
        sx={{ borderRadius:2}}
        p=".5rem 1rem 1rem 1rem"
    >

      <Box dispay="flex" alignContent="center" mb=".2rem"><Typography variant="h3" align="center">Image Info</Typography></Box>
      
      <Typography 
        noWrap 
        onClick ={handleNameChangeOpen} 
        sx={{cursor:"pointer"}}
      >
          Name: {thisImage.name}
      </Typography>

      {/* <Typography noWrap>Frame: {thisImage.selectedFrame}</Typography> */}
      <Typography>Width: {thisImage.width}</Typography>
      <Typography>Height: {thisImage.height}</Typography>
      <Typography>Frames: {totalFrames}</Typography>
      <Typography>Default Duration: {defaultDuration / 1000}s</Typography>
      {totalFrames > 1 &&
        <Typography>Animation Duration: {totalDuration / 1000}s</Typography>
      }


    </Box>

    </>

  );
}

export default InfoArea;